// services/authService.ts
import { api } from "./api";
import { loginSchema } from "../validators/schemas";

export interface LoginResponse {
  token: string;
  usuario: {
    idUsuario: number;
    usuario: string;
    idRol: number;
    idEmpleado: number;
  };
  expiresIn: string;
}

export const AuthService = {
  login: (credentials: { usuario: string; pass: string }) => {
    // Validar entrada
    const validated = loginSchema.parse(credentials);
    return api.post<LoginResponse>("/auth/login", validated);
  },

  logout: () => api.post("/auth/logout"),

  // Verificar si el usuario sigue autenticado
  verify: () => api.get("/auth/verify"),

  // Obtener verificaciones activas (solo para admin)
  getVerificaciones: () => api.get("/auth/verificacionesActivas"),
};
